import Container from './Container';

const DashboardsFavouriteBarContainer = Container;

export default DashboardsFavouriteBarContainer;
